import { MetricCard } from "./shared/MetricCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type RecoveryChart =
  | "RECOVERY_RATE"
  | "OVERALL_SOFT_DECLINE_RECOVERY"
  | "SOFT_DECLINE_COVERAGE";

type RecoveryKPIData = {
  rate: number;
  numerator: number;
  denominator: number;
  counts: {
    recovery_entered_intents: number;
    recovered_successful_intents: number;
    first_attempt_soft_decline_intents: number;
    soft_decline_recovery_entered_intents: number;
  };
  previous: {
    rate: number;
    numerator: number;
    denominator: number;
  };
  diff_percentage: number | null;
};

export function RecoveryRateCard({
  chartType,
  title,
  description,
}: {
  chartType: RecoveryChart;
  title: string;
  description: string;
}) {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<RecoveryKPIData>({ chartType });

  return (
    <MetricCard
      ref={ref}
      title={title}
      description={description}
      format="percentage"
      value={data?.rate ?? 0}
      diffPercentage={data?.diff_percentage ?? null}
      className="xl:aspect-[5/3]"
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
    />
  );
}
